type LogoutHandler = () => void
type LicenseBlockedHandler = (message: string | null) => void

let logoutHandler: LogoutHandler | null = null
let licenseBlockedHandler: LicenseBlockedHandler | null = null

export function registerLogoutHandler(handler: LogoutHandler): void {
    logoutHandler = handler
}

export function unregisterLogoutHandler(handler: LogoutHandler): void {
    if (logoutHandler === handler) {
        logoutHandler = null
    }
}

export function triggerLogoutHandler(): void {
    logoutHandler?.()
}

export function registerLicenseBlockedHandler(handler: LicenseBlockedHandler): void {
    licenseBlockedHandler = handler
}

export function unregisterLicenseBlockedHandler(handler: LicenseBlockedHandler): void {
    if (licenseBlockedHandler === handler) {
        licenseBlockedHandler = null
    }
}

export function triggerLicenseBlockedHandler(message: string | null): void {
    licenseBlockedHandler?.(message)
}
